import { combineEpics } from 'redux-observable';
import { fetchAllForecastProductGroupsEpic } from './fetch-all-products.epic';

export const combinedForecastProductGroupsEpics = combineEpics(fetchAllForecastProductGroupsEpic);
